module.exports = __webpack_public_path__ + "img/busdev.f2a4130b.png";